module.exports = __webpack_public_path__ + "media/images/down_arrow-8c158575c44f7b7884aae0da385d1583.gif";